<template lang="pug">
  .table-responsive
    table#tbMovimientos.table.is-striped.is-fullwidth.is-narrow(v-show="hayDatos")
      thead
        tr
          th 
            | Placa
          th 
            | Fecha
          th 
            | Km. Anterior
          th 
            | Km. Actual
          th 
            | Km. Recorridos
          th 
            | Total
      tbody
        tr(v-for="(mov, index) in movs" :key="mov.id")
          td.is-size-7(v-html="getPlaca(mov, index)")
            span.tag.is-black
          td.is-size-7
            span.tag
              | {{ mov.fecha }}
          td.is-size-7
            span.tag.is-light
              | {{ mov.kmAnterior }}
          td.is-size-7
            span.tag.is-light
              | {{ mov.kmActual }}
          td.is-size-7
            span.tag.is-light
              | {{ mov.kmRecorridos }}
          td.is-size-7(v-html="getTotal(mov, index)")
    .notification(v-show="!hayDatos")
      strong  No registros para esta búsqueda.
</template>

<script>
import moment from 'moment'

  export default {
    name: 'TbMovimientos',
    props: {
      movs: {
        type: Array,
        default: []
      },
      movSel: {
        type: Object,
        default () {
          return {
            vacio: true
          }
        }
      }
    },
    data() {
      return {
        hayDatos: true,
        itemsSelected: {},
        isDisabled: true,
      }
    },
    watch: {
      itemsSelected () {
        this.$emit('seleccionarItem', this.itemsSelected)
      },
      reset () {
        console.log(`Reset: ${this.reset}`)
        if (this.reset) {
          this.itemsSelected = {}
        }
      },
      movSel () {
        this.itemsSelected = Object.assign({}, this.itemsSelected, this.movSel)
      },
      
    },
    methods: {
      iniciarComponente () {

      },

      isFinSemana (fecha) {
        console.log(fecha)
        const _dia = moment(fecha).format('d')
        if (_dia == 0 || _dia == 6) {
          return 'is-danger'
        } else {
          return 'is-light'
        }
      },
      getPlaca(mov, index) {
        let placa = ''
        // Si el siguiente es diferente, que imprima
        if (index < this.movs.length - 1 ) {
          if (mov.placa !== this.movs[index+1].placa) {
            placa = `<span class="tag is-medium is-black">
            ${mov.placa}
            </span>`
          } 
        } else {
          placa = `<span class="tag is-medium is-black">
            ${mov.placa}
            </span>`
        }
        return placa
      },
      getTotal(mov, index) {
        let total
        if (index < this.movs.length - 1 ) {
          if (mov.placa !== this.movs[index+1].placa) {
            const movs = this.movs.filter( m => m.placa === mov.placa)
            const result = movs.reduce((acc, { kmRecorridos }) => acc + Number(kmRecorridos), 0)
            total = `<span class="tag is-medium is-black">
            ${result}
            </span>`
          }
        } else {
          const result = mov.kmRecorridos
          total = `<span class="tag is-medium is-black">
            ${result}
          </span>`
        }

        return total
      }
    }
  }
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/combustibles_Componentes/componentes/Tb_MovimientosTarjetas.vue